import type { VFXEffectConfig, VFXPrimitive } from '../../VFXEffectRegistry';
import { abilityPalette } from '../../abilityPalette';

const palette = abilityPalette('curse_of_elements')?.palette ?? [];
export const VEILBREAK_STYLE = {
  panel: [23, -22, 33, -25, 37, -8, 30, -2, 35, 17, 27, 23, 24, 5, 28, -5],
  seam: [{ x: 30, y: -18 }, { x: 32, y: -10 }, { x: 27, y: -3 }, { x: 31, y: 6 }, { x: 29, y: 16 }],
  depth: 101, panelAlpha: 0.8, seamAlpha: 0.95, seamWidth: 1.8,
  castDuration: 240, contactDuration: 320,
} as const;

function panels(): VFXPrimitive[] {
  return [-1, 1].map(side => ({ type: 'polygon',
    polygonPoints: VEILBREAK_STYLE.panel.map((value, index) => index % 2 ? value : value * side),
    color: palette[0], alpha: VEILBREAK_STYLE.panelAlpha, depth: VEILBREAK_STYLE.depth }));
}
function seams(): VFXPrimitive[] {
  return [-1, 1].map(side => ({ type: 'line',
    linePoints: VEILBREAK_STYLE.seam.map(point => ({ x: point.x * side, y: point.y })),
    color: palette[2], alpha: VEILBREAK_STYLE.seamAlpha,
    lineWidth: VEILBREAK_STYLE.seamWidth, depth: VEILBREAK_STYLE.depth + 1 }));
}

export const WARLOCK_VEIL_VFX: VFXEffectConfig[] = [
  { id: 'veilbreak_cast', name: 'Veilbreak Release', category: 'burst',
    description: 'A violet slit parts into two pale-edged fragments at the hand',
    primitives: [-1, 1].map((side): VFXPrimitive => ({ type: 'polygon',
      polygonPoints: [3 * side, -15, 9 * side, -8, 5 * side, 2, 8 * side, 13, 2 * side, 8],
      color: side < 0 ? palette[0] : palette[1], alpha: 0.85, depth: 102,
      tween: { x: side * 7, alpha: 0, scale: 1.2, duration: VEILBREAK_STYLE.castDuration } })) },
  { id: 'veilbreak_contact', name: 'Veilbreak Contact', category: 'burst',
    description: 'The struck veil parts at its edges, leaving a clear space around the target face',
    primitives: [...panels(), ...seams()].map((primitive, index) => ({ ...primitive,
      tween: { x: index % 2 ? 5 : -5, alpha: 0, scale: 1.12, duration: VEILBREAK_STYLE.contactDuration } })) },
  { id: 'curse_of_elements_state', name: 'Veilbreak Exposure', category: 'status',
    description: 'Two split violet panels and pale fractures mark the exposed target',
    followTarget: 'player', minimumShapes: 2,
    // Essential bilateral panels allocate before optional seam accents.
    // The accepted status owns all lifetime; no local pulse or clock.
    primitives: [...panels(), ...seams()] },
];
